import type { CmsData, MenuType } from '../../../interfaces';
import { SchemaOrg } from '../SchemaOrg/SchemaOrg';
import { ContentWithMenu } from './ContentWithMenu.client';
import { RegisteredCmsComponents } from './RegisteredCmsComponents';

const contentWidthStyle = {
  standard: '[--shop-max-width:71.25rem]',
  wide: '[--shop-max-width:90rem]',
  wider: '[--shop-max-width:105rem]',
  widest: '[--shop-max-width:121.25rem]',
  full: '[--shop-max-width:100vw] lg:-ml-1 lg:w-[calc(100%+1rem)]',
} as const;

export const Content = ({
  data,
  menuData,
  token,
}: {
  data: CmsData;
  menuData?: MenuType;
  token?: string;
}) => {
  const pageTemplate = data.type === 'storefront_content' ? 'homepage' : 'ServiceUndHilfe';

  const { field_maximum_content_width: contentWidth = 'standard' } = data;

  const content = (
    <RegisteredCmsComponents
      paragraphs={data.paragraph}
      pageTemplate={pageTemplate}
      token={token}
    />
  );

  return (
    <div
      className={`shop-content ${contentWidthStyle[contentWidth] ?? contentWidthStyle.standard}`}
    >
      <SchemaOrg data={data} />
      {menuData ? (
        <ContentWithMenu menuData={menuData} currentPath={data.path?.[0].alias}>
          {content}
        </ContentWithMenu>
      ) : (
        content
      )}
    </div>
  );
};
